document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.shopify-payment-button__button--unbranded')
        .forEach(function (btn) {
            if (/^buy\s*it\s*now$/i.test(btn.textContent.trim())) {
                btn.textContent = 'Buy Now';
            }
        });
});